export default {
  SET_EDITOR_STATE: 'EDITOR/SET_STATE',
  SET_RAW_EDITOR_STATE: 'EDITOR/SET_RAW_STATE',
  SET_CURRENT_STATE: 'EDITOR/SET_CURRENT_STATE', // Do not use outside of the editor
  CLEAR: 'EDITOR/CLEAR',
}
